// redux/reducers/class.ts

import {ClassActions, SET_SELECTED_CLASS, SET_CLASS_STUDENTS, ClassStudent} from '../actions/class';

export interface ClassState {
  selectedClassId: string | null;
  classStudents: {
    [classId: string]: ClassStudent[];
  };
}

const initialState: ClassState = {
  selectedClassId: null,
  classStudents: {},
};

export function classReducer(
  state = initialState,
  action: ClassActions,
): ClassState {
  switch (action.type) {
    case SET_SELECTED_CLASS:
      return {...state, selectedClassId: action.payload};
    case SET_CLASS_STUDENTS:
      return {
        ...state,
        classStudents: {
          ...state.classStudents,
          [action.payload.classId]: action.payload.students,
        },
      };
    default:
      return state;
  }
}
